var map = {
	"./Contracting/Contracting1.mp4": 9054,
	"./Contracting/Contracting2.mp4": 4737,
	"./Contracting/Contracting3.mp4": 5236,
	"./Contracting/Contracting4.mp4": 9896,
	"./Contracting/Contracting5.mp4": 4416,
	"./Contracting/Contracting6.mp4": 5915,
	"./Contracting/Contracting7.mp4": 4398,
	"./Janitorial/Janitorial1.mp4": 7369,
	"./Janitorial/Janitorial2.mp4": 8713,
	"./Janitorial/Janitorial3.mp4": 2600,
	"./Janitorial/Janitorial4.mp4": 3471,
	"./Janitorial/Janitorial5.mp4": 4882,
	"./Janitorial/Janitorial6.mp4": 8495,
	"./Janitorial/Janitorial7.mp4": 7350,
	"./Janitorial/Janitorial8.mp4": 5274
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1190;